
import { Map, fromJS } from 'immutable';
import { v1 as uuidv1 } from 'uuid';
import uuidTime from 'uuid-time';


export default (() => {
  let _cache = Map();

  const generateTimestamp = () => uuidv1();

  const get = (sourceId) => _cache.get(sourceId)?.toJS();

  const set = (sourceId, sourceIdWithTimestamp) => {
    _cache = _cache.set(sourceId, fromJS(sourceIdWithTimestamp));
  };

  const isCachedTimestampLatest = (sourceId, timestamp) => {
    const timestampInCache = get(sourceId)?.timestamp;
    if (!timestampInCache) {
      return false;
    }

    return uuidTime.v1(timestampInCache) >= uuidTime.v1(timestamp);
  };

  const updateIfLatest = (sourceId, timestamp) => {
    const timestampInCache = get(sourceId)?.timestamp;
    if (timestampInCache === timestamp) {
      set(sourceId, { timestamp, receivedResponseFromServer: true });
    }
  };

  return {
    generateTimestamp,
    get,
    set,
    isCachedTimestampLatest,
    updateIfLatest,
  };
})();
